// frontend/src/components/reports/ReportTable.js

import React from "react";

const ReportTable = ({ tasks, loading }) => {
  if (loading) {
    return (
      <div className="text-center py-8 text-blue-600 font-semibold">
        ⏳ Loading data, please wait...
      </div>
    );
  }

  if (!tasks || tasks.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500 italic">
        No records found for the selected filters.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto bg-white shadow rounded-lg border border-gray-200">
      <table className="min-w-full table-auto text-sm">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="px-4 py-2 text-left">ID</th>
            <th className="px-4 py-2 text-left">Title</th>
            <th className="px-4 py-2 text-left">Assigned To</th>
            <th className="px-4 py-2 text-left">Status</th>
            <th className="px-4 py-2 text-left">Priority</th>
            <th className="px-4 py-2 text-left">Category</th>
            <th className="px-4 py-2 text-left">Due Date</th>
            <th className="px-4 py-2 text-left">Created At</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr
              key={task.id}
              className="border-t hover:bg-gray-50 transition-colors duration-150"
            >
              <td className="px-4 py-2">{task.id}</td>
              <td className="px-4 py-2 font-medium">{task.title}</td>
              <td className="px-4 py-2">
                {task.assigned_to || <span className="text-gray-400">N/A</span>}
              </td>
              <td
                className={`px-4 py-2 font-semibold ${
                  task.status === "Completed"
                    ? "text-green-600"
                    : task.status === "Pending"
                    ? "text-yellow-600"
                    : task.status === "In Progress"
                    ? "text-blue-600"
                    : "text-gray-700"
                }`}
              >
                {task.status}
              </td>
              <td className="px-4 py-2">{task.priority}</td>
              <td className="px-4 py-2">{task.category}</td>
              <td className="px-4 py-2">
                {task.due_date ? task.due_date.split("T")[0] : "-"}
              </td>
              <td className="px-4 py-2">
                {task.created_at ? task.created_at.split("T")[0] : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;

